import React, { Fragment, useContext, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Box from "@mui/material/Box";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import logoTechMatch from "./../../../img/rexcornu_techmatch_logo_20230410_01.svg";
import { Grid, Paper, Typography, IconButton, MenuItem } from "@mui/material";
import { globalContext } from "../../../App";
import {
  useLocalStorage,
  removeLocalStorage,
} from "../../../hooks/localStrage";
import MenuIcon from "@mui/icons-material/Menu";
import naviPc from "./../../../img/nav-pc.svg";
import navBoard from "./../../../img/nav-board.svg";
import PostAddIcon from "@mui/icons-material/PostAdd";
import CloseIcon from "@mui/icons-material/Close";

export default function ElementSmartphone() {
  const { setRerendering, rerendering } = useContext(globalContext);
  const navigate = useNavigate();
  const [, setCurrentPage] = useLocalStorage("currentPage");
  const handleCloseNavMenu = (url, currentPage) => {
    setCurrentPage(currentPage);
    navigate(url);
    setRerendering(!rerendering);
  };
  const handleLogout = () => {
    removeLocalStorage([
      "token",
      "PersonnelSearchCriteriaFromConditions",
      "PersonnelSearchCriteriaFromRecruitment",
      "recuruitmentSearchCondition",
    ]);
    window.localStorage.removeItem("token");
    handleCloseNavMenu("/", process.env.REACT_APP_DASHBOARD_NUM);
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleClick = () => {
    setIsMenuOpen(true);
  };

  return (
    <Fragment>
      <Box sx={{ display: "flex" }}>
        <Grid container direction="column" justifyContent="center">
          <Grid item xs={8} justifyItems="right">
            <Link
              to="/dashboard"
              onClick={() => {
                setCurrentPage(process.env.REACT_APP_DASHBOARD_NUM);
              }}
            >
              <img src={logoTechMatch} width="200px" />
            </Link>
          </Grid>
          <Grid item xs={4}>
            <Box
              display="flex"
              sx={{ justifyContent: "flex-end", marginTop: "-10px" }}
            >
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
                size="small"
              >
                <MenuIcon />
              </IconButton>

              <Paper
                id="long-menu"
                sx={{
                  visibility: isMenuOpen ? "visible" : "hidden",
                  opacity: isMenuOpen ? 1 : 0,
                  height: "100vh",
                  width: "100vw",
                  transform: isMenuOpen ? "scale(1)" : "scale(0)",
                  top: 0,
                  left: 0,
                  position: "fixed",
                  zIndex: "1300",
                  transition: `opacity 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 266ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, visibility 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
                  transformOrigin: "calc(100% - 25px) 42px",
                  pt: "20px",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingRight: "15px",
                  }}
                >
                  <IconButton
                    sx={{ width: "40px", height: "40px", borderRadius: "50%" }}
                  >
                    <CloseIcon onClick={() => setIsMenuOpen(false)} />
                  </IconButton>
                </Box>

                <MenuItem
                  onClick={() => {
                    handleCloseNavMenu(
                      "dashboard",
                      process.env.REACT_APP_DASHBOARD_NUM
                    );
                    setIsMenuOpen(false);
                  }}
                >
                  <ListItemIcon>
                    <HomeOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    primary={
                      <Typography fontSize="24px">ダッシュボード</Typography>
                    }
                  />
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    handleCloseNavMenu(
                      "personnelListPage",
                      process.env.REACT_APP_PERSONNELLIST_NUM
                    );
                    setIsMenuOpen(false);
                  }}
                >
                  <ListItemIcon>
                    <img src={naviPc} width="24px" height="18px" />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    primary={<Typography fontSize="24px">要員</Typography>}
                  />
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleCloseNavMenu(
                      "recruitmentListPage",
                      process.env.REACT_APP_RECRUITMENTLIST_NUM
                    );
                    setIsMenuOpen(false);
                  }}
                >
                  <ListItemIcon>
                    <img src={navBoard} width="24px" height="18px" />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    primary={<Typography fontSize="24px">募集</Typography>}
                  />
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    handleCloseNavMenu(
                      "projectRegister",
                      process.env.REACT_APP_DASHBOARD_NUM
                    );
                    setIsMenuOpen(false);
                  }}
                >
                  <ListItemIcon>
                    <PostAddIcon />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    primary={<Typography fontSize="24px">募集登録</Typography>}
                  />
                </MenuItem>

                {(() => {
                  if (
                    Number(localStorage.getItem("adminFlag")) ===
                      Number(process.env.REACT_APP_BP_MANAGEMENT_CLASS) ||
                    Number(localStorage.getItem("adminFlag")) ===
                      Number(process.env.REACT_APP_MANAGEMENT_CLASS)
                  ) {
                    return (
                      <MenuItem
                        onClick={() => {
                          handleCloseNavMenu(
                            "adminManagement",
                            process.env.REACT_APP_ADMINMANAGEMENT_NUM
                          );
                          setIsMenuOpen(false);
                        }}
                      >
                        <ListItemIcon>
                          <PersonOutlineIcon />
                        </ListItemIcon>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography fontSize="24px">ユーザ管理</Typography>
                          }
                        />
                      </MenuItem>
                    );
                  }
                })()}

                {(() => {
                  if (
                    Number(localStorage.getItem("adminFlag")) ===
                    Number(process.env.REACT_APP_GENERAL_CLASS)
                  ) {
                    return (
                      <MenuItem
                        onClick={() => {
                          handleCloseNavMenu(
                            "userChangeInfo",
                            process.env.REACT_APP_USERCHANGEINFO_NUM
                          );
                          setIsMenuOpen(false);
                        }}
                      >
                        <ListItemIcon>
                          <PersonOutlineIcon />
                        </ListItemIcon>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography fontSize="24px">
                              ユーザ情報変更
                            </Typography>
                          }
                        />
                      </MenuItem>
                    );
                  }
                })()}
                <MenuItem
                  onClick={() => {
                    window.open(
                      "https://dwarfstella.atlassian.net/wiki/spaces/TechMatchm/pages/33849348/TechMatch",
                      "_blank"
                    );
                    setIsMenuOpen(false);
                  }}
                >
                  <ListItemIcon>
                    <MenuBookIcon />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    primary={
                      <Typography fontSize="24px">マニュアル</Typography>
                    }
                  />
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    window.open(
                      "https://dwarfstella.atlassian.net/wiki/spaces/TechMatchm/pages/33914881/TechMatch+FAQ",
                      "_blank"
                    );
                    setIsMenuOpen(false);
                  }}
                >
                  <ListItemIcon>
                    <HelpOutlineIcon />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    primary={<Typography fontSize="24px">FAQ</Typography>}
                  />
                </MenuItem>
                <MenuItem onClick={() => handleLogout()}>
                  <ListItemIcon>
                    <LogoutIcon />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    primary={
                      <Typography fontSize="24px">ログアウト</Typography>
                    }
                  />
                </MenuItem>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  );
}
